import React from 'react';
import { CreditCard, Landmark } from 'lucide-react';
export function PortalPaymentOptions() {
  return <section className="py-12 bg-white" data-id="element-617">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-618">
        <p className="text-sm font-semibold text-brand-muted uppercase tracking-wider mb-6" data-id="element-619">
          Accepted Payment Methods
        </p>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 opacity-70" data-id="element-620">
          <div className="flex flex-col items-center gap-2" data-id="element-621">
            <CreditCard size={32} className="text-brand-navy" data-id="element-622" />
            <span className="text-xs font-medium text-brand-dark" data-id="element-623">Visa</span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-624">
            <CreditCard size={32} className="text-brand-navy" data-id="element-625" />
            <span className="text-xs font-medium text-brand-dark" data-id="element-626">
              Mastercard
            </span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-627">
            <CreditCard size={32} className="text-brand-navy" data-id="element-628" />
            <span className="text-xs font-medium text-brand-dark" data-id="element-629">
              Discover
            </span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-630">
            <CreditCard size={32} className="text-brand-navy" data-id="element-631" />
            <span className="text-xs font-medium text-brand-dark" data-id="element-632">AmEx</span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-633">
            <Landmark size={32} className="text-brand-navy" data-id="element-634" />
            <span className="text-xs font-medium text-brand-dark" data-id="element-635">
              ACH / eCheck
            </span>
          </div>
        </div>
        <p className="mt-8 text-sm text-brand-muted" data-id="element-636">
          Multiple secure payment methods available. We never store your card
          details.
        </p>
      </div>
    </section>;
}